import React, { useState, useEffect } from 'react';
import axios from "../../common/axios";
import { Alert } from 'antd';
import CircularLoader from '../../common/CircularLoader';
import Test from "../../tests/student/assessments/Test";

const TestActivity = ({ step, pathwayUser, continueCurrentStep }) => {
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [testAssignment, setTestAssignment] = useState(null);
    const [testResult, setTestResult] = useState(null);

    useEffect(() => {
        if (!pathwayUser || !step) {
            setTestAssignment(null);
            setTestResult(null);
            setError(null);
            setLoading(false);
            return;
        }

        const fetchTestData = async () => {
            try {
                setLoading(true);
                const response = await axios.get('/web/ui/test/trail/start', {
                    params: {
                        pathwayUserId: pathwayUser.pathwayUserId,
                        stepId: step.stepId
                    }
                });

                setTestAssignment(response.data.testAssignment);
                setTestResult(response.data.testResult);
            } catch (err) {
                console.error('Failed to load test assignment:', err);
                setError("Unable to load test assignment.");
                setTestAssignment(null);
            } finally {
                setLoading(false);
            }
        };

        fetchTestData();
    }, [pathwayUser, step]);

    if (isLoading || !pathwayUser || !step) {
        return <CircularLoader />;
    }

    if (error) {
        return (
            <Alert
                type="error"
                showIcon
                message="Error"
                description={error}
            />
        );
    }

    if (!testAssignment) {
        return (
            <Alert
                type="error"
                showIcon
                message="Test Not Found"
                description="No test assignment was returned by the server."
            />
        );
    }

    return (
        <div className="ch-trail-test">
            <Test
                trailTestAssignmentId={testAssignment.testAssignmentId}
                onContinue={continueCurrentStep}
            />
        </div>
    );
};

export default TestActivity;